import {
    SEND_WELCOME_EMAIL_OPEN_MODAL,
    SEND_WELCOME_EMAIL_CLOSE_MODAL,
    SEND_WELCOME_EMAIL_REQUEST,
    SEND_WELCOME_EMAIL_RESULT,
} from 'Redux/actionTypes';

export const sendWelcomeEmailOpenModal = (data) => ({
    type: SEND_WELCOME_EMAIL_OPEN_MODAL,
    payload: data
})

export const sendWelcomeEmailCloseModal = () => ({
    type: SEND_WELCOME_EMAIL_CLOSE_MODAL
})

export const sendWelcomeEmailRequest = (data) => ({
    type: SEND_WELCOME_EMAIL_REQUEST,
    payload: data
})

export const sendWelcomeEmailResult = (result) => ({
    type: SEND_WELCOME_EMAIL_RESULT,
    payload: result
})